import { h, Component } from 'preact';
import { pause } from 'helpers';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/main/cursor/cursor.sss';
import Store from 'store/store';

export default class Cursor extends Component {
	constructor(props) {
		super(props);
		this.props = props;

		this.mouseX = 0;
		this.mouseY = 0;
		this.lastMouseX = 0;
		this.lastMouseY = 0;
		this.hoveringOnStar = false;

		this.state = {
			cursorOpacity: 1,
			positions: [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0][0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
			// clicked: false
			cursorOverButton: false
		};

		this.mouseMove = this.mouseMove.bind(this);
		this.mouseLeave = this.mouseLeave.bind(this);
		//this.onClick = this.onClick.bind(this);
		this.updatePos = this.updatePos.bind(this);
		this.animate = this.animate.bind(this);
		this.onMushroomedCursor = this.onMushroomedCursor.bind(this);
		this.onDuplicatedCursor = this.onDuplicatedCursor.bind(this);
	}

	componentDidMount() {		
		window.addEventListener('mousemove', (event) => { 
			this.mouseMove(event);
		});
		window.addEventListener('mouseout', this.mouseLeave);
		this.animate();	

		Store.on('HOVER_ON_STAR', (hoveringOnStar) => {
			this.hoveringOnStar = hoveringOnStar;
		});
		Store.on('MUSHROOMED_CURSOR', this.onMushroomedCursor);
		Store.on('DUPLICATED_CURSOR', this.onDuplicatedCursor);
	}

	componentWillUnmount() {
		window.removeEventListener('mousemove', this.mouseMove);
		window.removeEventListener('mouseout', this.mouseLeave);
		this.animationFrame && window.cancelAnimationFrame(this.animationFrame);
		Store.off('MUSHROOMED_CURSOR', this.onMushroomedCursor);
		Store.off('DUPLICATED_CURSOR', this.onDuplicatedCursor);
	}

	async onMushroomedCursor() {
		this.setState({ mushroomed: true });
		await pause(3100);
		this.setState({ mushroomed: false });
	}

	async onDuplicatedCursor() {
		this.setState({ duplicated: true });
		await pause(2600);
		this.setState({ duplicated: false });
	}

	mouseMove(e) {
		this.mouseX = e.clientX;
		this.mouseY = e.clientY;		
		this.setState({ cursorOpacity: 1 });	
		const clickable = e.target.closest('#clickable');
		const button = e.target.closest('button');

		const { cursorOverButton } = this.state;

		if (clickable || button || this.hoveringOnStar) {
			if (!cursorOverButton) {
				this.setState({ cursorOverButton: true });
			}
		} else {
			if (cursorOverButton) {
				this.setState({ cursorOverButton: false });
			}
		}
	}

	mouseLeave() {
		this.setState({ cursorOpacity: 0 });
	}


	updatePos() {
		const { positions } = this.state;
		let pos = [];
		pos = positions;
		for (let i = 0; i < 8; i++) {
			pos.push([this.lastMouseX + (((this.mouseX - this.lastMouseX) / 8) * i), this.lastMouseY + (((this.mouseY - this.lastMouseY) / 8) * i)]);
			pos.shift();
		}
		
		this.setState({ positions: pos });
		this.lastMouseX = this.mouseX;
		this.lastMouseY = this.mouseY;				
	}

	animate() {
		this.animationFrame = window.requestAnimationFrame(this.animate);
		this.updatePos();
	}	

	render() {
		const { imageRoot } = this.props;
		const { positions, cursorOpacity, cursorOverButton, mushroomed, duplicated } = this.state;

		const starStyle = { transform: `translate(${positions[positions.length - 1][0]}px,${positions[positions.length - 1][1]}px)`, opacity: `${cursorOpacity}` };
		const shadowStyle = { transform: `translate(${positions[positions.length - 1][0]}px,${positions[positions.length - 1][1]}px)`, opacity: cursorOverButton ? `${cursorOpacity}`: 0};

		return (
			<div class={s.container}>
	
				<img src={`${imageRoot}/cursor/tdv9j3.svg`} style={starStyle} class ={joinClasses(s.cursor, mushroomed && s.mushroomed)} />
				<img src={`${imageRoot}/cursor/tdv9j3.svg`} style={starStyle} class ={joinClasses(s.cursor, s.hiddenCursor, duplicated && s.duplicated)} />
				<img src={`${imageRoot}/cursor/mk4dxp.webp`} style={shadowStyle} class ={s.shadow} />
				{Object.values(positions).map((pos, i) => {
					const style = { transform: `translate(${pos[0]}px,${pos[1]}px)`, opacity: `${cursorOpacity * ((cursorOpacity / positions.length) * i)}`, filter: `blur(${(1 - (i / positions.length)) * 3}px)`, width: `${(((1 / positions.length) * i) * 16)}px`, height: `${ (((1 / positions.length) * i) * 16)}px`, marginLeft: `${(((1 / positions.length) * i) * -8)}px`, marginTop: `${(((1 / positions.length) * i) * -8)}px`, position: 'absolute' };
					return (					
						<img src={`${imageRoot}/cursor/cr0d5v.webp`} style={style} />
					);
				})}
			</div>
		);
	}
}